import { Box, SectionHeader, TouchableBox } from "arkh";
import React, { PropsWithChildren } from "react";
import { ListItemEditIcon } from "./ListItemEditIcon";

export function SectionContainer(
  props: PropsWithChildren<{
    title: string;
    onPress?(): void;
  }>
) {
  return (
    <Box spaceBottom="large">
      <SectionHeader
        right={
          props.onPress ? (
            <TouchableBox onPress={props.onPress} spaceHorizontal="xsmall">
              <ListItemEditIcon />
            </TouchableBox>
          ) : null
        }
      >
        <SectionHeader.Title>{props.title}</SectionHeader.Title>
      </SectionHeader>
      {props.children}
    </Box>
  );
}
